<ion-header
  class="ion-no-border"
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        data-cy="close-support-center-modal-button"
        (click)="onDidDismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content
  scroll-y="true"
  data-cy="support-center-modal-area-text"
  class="content"
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid>
    <ion-row>
      <ion-col class="support-center-title">
        <h3 class="margin-right">
          {{ modalTitle | translate }}
        </h3>
        <h3 *ngIf="supportItem?.caseNumber">#{{ supportItem.caseNumber }}</h3>
      </ion-col>
    </ion-row>
    <ion-row
      class="support-center-status"
      [class.info-icon]="
        !supportItem.isMoxeOriginated &&
        !!supportItem.caseNumber &&
        !supportItem.isResubmitting
      "
    >
      <ion-col
        *ngIf="
          supportItem.status !== supportRef.FAILED ||
          !!supportItem.isResubmitting
        "
      >
        <ng-container [ngTemplateOutlet]="status"> </ng-container>
      </ion-col>
      <ion-col
        *ngIf="
          supportItem.status === supportRef.FAILED &&
          !supportItem.isResubmitting
        "
      >
        <ion-row>
          <p
            class="report-heading failure-message no-margin"
            *ngIf="platformEnum.mobile !== platformType"
          >
            {{ ('i18n.supportCenter.status.fail' | translate) + '. ' }}
            <span class="report-message failure-message">{{
              'i18n.supportCenter.failureMessage' | translate
            }}</span>
          </p>
          <p *ngIf="platformEnum.mobile === platformType">
            <span class="report-heading failure-message">
              {{ ('i18n.supportCenter.status.fail' | translate) + '. ' }}
            </span>
            <span class="report-message failure-message">
              {{ 'i18n.supportCenter.failureMessage' | translate }}
            </span>
          </p>
        </ion-row>
      </ion-col>
    </ion-row>
    <ion-row
      class="outside-moxe"
      *ngIf="
        !supportItem.isMoxeOriginated &&
        !!supportItem.caseNumber &&
        !supportItem.isResubmitting
      "
    >
      <ion-col size="12">
        <ion-icon
          class="outside-moxe-icon"
          data-cy="outside-moxe-indicator"
          name="information-circle-outline"
        >
        </ion-icon>
        <p class="outside-moxe-message">
          {{ 'i18n.supportCenter.card.popover' | translate }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="
        supportItem.serviceRequestType !== serviceRequestType.SUPPORT_REQUEST
      "
    >
      <span class="report-heading"
        >{{ 'i18n.supportCenter.product' | translate }}:</span
      >
    </ion-row>
    <ion-row
      *ngIf="
        supportItem.serviceRequestType !== serviceRequestType.SUPPORT_REQUEST
      "
    >
      <span class="report-data margin-left">
        #{{ supportItem.productNumber ? supportItem.productNumber : 'N/A' }}
        {{ supportItem.productName ? ' - ' + supportItem.productName : '' }}
      </span>
    </ion-row>
    <ion-row *ngIf="platformType !== platformEnum.mobile">
      <!-- First column -->
      <ion-col>
        <p
          *ngIf="
            supportItem.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading">{{
            'i18n.supportCenter.card.invoice' | translate
          }}</span>
          <span class="report-data">{{
            !!supportItem.invoiceNumber ? supportItem.invoiceNumber : 'N/A'
          }}</span>
        </p>
        <p>
          <span class="report-heading">{{
            'i18n.supportCenter.card.date' | translate
          }}</span>
          <span class="report-data">{{
            supportItem?.submissionDate | date: 'M/d/yyyy'
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.issue' | translate }}:</span
          >
          <span class="report-data">{{ supportItem?.issue }}</span>
        </p>
        <p
          *ngIf="
            supportItem.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.quantity' | translate }}:</span
          >
          <span class="report-data">{{ supportItem?.quantity }}</span>
        </p>
        <p
          *ngIf="
            supportItem.serviceRequestType ===
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{
              'i18n.supportCenter.requestModal.requestReason' | translate
            }}:</span
          >
          <span class="report-data">{{ supportItem?.issueDetail }}</span>
        </p>
        <p>
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.attachments' | translate }}:</span
          >
          <span class="report-data">{{
            supportItem?.numberOfAttachments
          }}</span>
        </p>
        <!-- Comments in the first column if requestedDeliveryDate exists and is a Recovery Request-->
        <p *ngIf="isRecoveryRequest && supportItem?.requestedDeliveryDate">
          <span class="report-heading margin-right">
            {{ 'i18n.supportCenter.modal.comments' | translate }}:
          </span>
          <span class="report-data">{{
            !!supportItem.comment ? supportItem.comment : ('N/A' | translate)
          }}</span>
        </p>
      </ion-col>

      <!-- Second column -->
      <ion-col>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading">{{
            'i18n.supportCenter.card.order' | translate
          }}</span>
          <span class="report-data">{{
            !!supportItem.orderNumber ? supportItem.orderNumber : 'N/A'
          }}</span>
        </p>
        <!-- Requested Delivery Date in the second column if exists and  is a recovery request-->
        <p *ngIf="isRecoveryRequest && supportItem?.requestedDeliveryDate">
          <span class="report-heading">
            {{ 'i18n.supportCenter.card.requestedDeliveryDate' | translate }}
          </span>
          <span class="report-data">{{
            supportItem.requestedDeliveryDate | date: 'M/d/yyyy'
          }}</span>
        </p>
        <p>
          <span class="report-heading">{{
            'i18n.supportCenter.card.user' | translate
          }}</span>
          <span class="report-data">{{ formattedUserName }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.issueDetail' | translate }}:</span
          >
          <span class="report-data">{{
            supportItem?.issueDetail | translate
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.quantityType' | translate }}:</span
          >
          <span class="report-data">
            {{
              (isValidUnitType
                ? 'i18n.supportCenter.modal.' + supportItem.unitOfMeasure
                : 'N/A'
              ) | translate
            }}</span
          >
        </p>
        <!-- Comments in the second column if is not a recovery request and requested delivery date doesn't exist -->
        <p
          *ngIf="
            !isRecoveryRequest &&
            !supportItem?.requestedDeliveryDate &&
            supportItem?.serviceRequestType !==
              serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.comments' | translate }}:</span
          >
          <span class="report-data">{{
            !!supportItem.comment ? supportItem.comment : ('N/A' | translate)
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType ===
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.common.email' | translate }}:</span
          >
          <span class="report-data">{{
            !!supportItem.email ? supportItem.email : ('N/A' | translate)
          }}</span>
        </p>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="
        supportItem?.serviceRequestType ===
          serviceRequestType.SUPPORT_REQUEST &&
        platformType !== platformEnum.mobile
      "
      class="support-comments"
    >
      <ion-col>
        <span class="report-heading margin-right">
          {{ 'i18n.supportCenter.modal.comments' | translate }}:
        </span>
        <span class="report-data">{{
          !!supportItem.comment ? supportItem.comment : ('N/A' | translate)
        }}</span>
      </ion-col>
    </ion-row>
    <ion-row
      class="mobile-details-container"
      *ngIf="platformType === platformEnum.mobile"
    >
      <ion-col>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading">{{
            'i18n.supportCenter.card.invoice' | translate
          }}</span>
          <span class="report-data">{{
            !!supportItem.invoiceNumber ? supportItem.invoiceNumber : 'N/A'
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading">{{
            'i18n.supportCenter.card.order' | translate
          }}</span>
          <span class="report-data">{{
            !!supportItem.orderNumber ? supportItem.orderNumber : 'N/A'
          }}</span>
        </p>
        <p>
          <span class="report-heading">{{
            'i18n.supportCenter.card.date' | translate
          }}</span>
          <span class="report-data">{{
            supportItem?.submissionDate | date: 'M/d/yyyy'
          }}</span>
        </p>
        <p *ngIf="isRecoveryRequest && supportItem?.requestedDeliveryDate">
          <span class="report-heading">
            {{ 'i18n.supportCenter.card.requestedDeliveryDate' | translate }}
          </span>
          <span class="report-data">{{
            supportItem.requestedDeliveryDate | date: 'M/d/yyyy'
          }}</span>
        </p>
        <p>
          <span class="report-heading">{{
            'i18n.supportCenter.card.user' | translate
          }}</span>
          <span class="report-data">{{ formattedUserName }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.issue' | translate }}:</span
          >
          <span class="report-data">{{ supportItem?.issue }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.issueDetail' | translate }}:</span
          >
          <span class="report-data">{{
            supportItem?.issueDetail | translate
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType ===
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{
              'i18n.supportCenter.requestModal.requestReason' | translate
            }}:</span
          >
          <span class="report-data">{{
            supportItem?.issueDetail | translate
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.quantity' | translate }}:</span
          >
          <span class="report-data">{{ supportItem?.quantity }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType !==
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.quantityType' | translate }}:</span
          >
          <span class="report-data">{{
            (supportItem?.unitOfMeasure
              ? 'i18n.supportCenter.modal.' + supportItem.unitOfMeasure
              : 'N/A'
            ) | translate
          }}</span>
        </p>
        <p
          *ngIf="
            supportItem?.serviceRequestType ===
            serviceRequestType.SUPPORT_REQUEST
          "
        >
          <span class="report-heading margin-right"
            >{{ 'i18n.common.email' | translate }}:</span
          >
          <span class="report-data">{{
            !!supportItem.email ? supportItem.email : 'N/A'
          }}</span>
        </p>
        <p>
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.attachments' | translate }}:</span
          >
          <span class="report-data">{{
            supportItem?.numberOfAttachments
          }}</span>
        </p>
        <p>
          <span class="report-heading margin-right"
            >{{ 'i18n.supportCenter.modal.comments' | translate }}:</span
          >
          <span class="report-data">{{
            !!supportItem.comment ? supportItem.comment : ('N/A' | translate)
          }}</span>
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platformType !== platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="support-center-modal-cancel-button"
        [ngClass]="
          platformType === platformEnum.desktop
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="onDidDismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        *ngIf="
          supportItem.status === supportRef.FAILED &&
          !supportItem.caseNumber &&
          !supportItem.isResubmitting
        "
        data-cy="cost-report-modal-resubmit-button"
        [ngClass]="
          platformType === platformEnum.desktop
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="resubmit()"
      >
        {{ 'i18n.supportCenter.modal.resubmit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<ng-template #status>
  <app-support-center-status
    class="center-me"
    [status]="supportItem.status"
    [statusText]="supportItem.statusText"
    [serviceRequestType]="supportItem.serviceRequestType"
    [platform]="platformType"
    [isResubmitting]="supportItem.isResubmitting"
    [isCard]="false"
  >
  </app-support-center-status>
</ng-template>
